import lang from "@/views/modules/StudyBudgets/language/en";

let searchFieldsDef = {
    'name': {
        label: lang.LBL_TEMPLATE_NAME,
    },
    'currency_multiplier': {
        label: lang.LBL_CURRENCY_MULTIPLIER,
    },
    'template_year': {
        label: lang.LBL_TEMPLATE_YEAR,
    },
    'status': {
        label: lang.LBL_TEMPLATE_STATUS,
        type: 'checkbox',
        field_infos: 'template_status',
    },
};
export default { searchFieldsDef }